module.exports = __webpack_public_path__ + "static/media/entrantesyaperitivos.ed0bd62f.svg";